
import Vue from "vue";
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import { mapActions, mapMutations } from "vuex";
import Validation from "~/entities/Validation";
import ValidationAuth from "~/entities/ValidationModules/ValidationAuth";

export default Vue.extend({
  name: "Register",
  components: {
    VueTelInput,
  },
  data() {
    return {
      PhoneValidationRules: {
        inputOptions: {
          placeholder: "",
          required: true,
          maxlength: 20,
        },
        validCharactersOnly: true,
        mode: "international",
        dropdownOptions: {
          disabled: false,
          showDialCodeInList: true,
          showDialCodeInSelection: false,
          showFlags: true,
          showSearchBox: true,
          tabindex: 0,
          width: "390px",
        },
      },
      validation: new Validation(new ValidationAuth()),
      errors: false,
      disableBtn: true,
      company: "",
      firstName: "",
      lastName: "",
      phone: "",
      email: "",
      password: "",
      confirmPassword: "",
      isValidPhone: false as boolean,
      checkTerms: false,
      validPassword: true,
      rejectedPhone: false,
      rejectedEmail: false,
      rejectedPassword: false,
      mailingListOptIn: false,
      newsLetterOptIn: false,
      submitting: false,
      isEmailAvailable: true,
      invalidEmail: false,
    };
  },
  computed: {
    isDisabled(): any {
      const vPassword =
        /(?=^.{6,}$)((?=.*\d)|(?=.*\W+))(?![.\n])(?=.*[A-Z])(?=.*[a-z]).*$/;
      return (
        !(this as any).firstName ||
        !(this as any).lastName ||
        !this.invalidEmail ||
        !vPassword.test((this as any).password) ||
        (this as any).disableBtn ||
        !(this as any).checkTerms ||
        !(this as any).isEmailAvailable
      );
    },
  },
  watch: {
    email() {
      this.checkEmail();
    },
  },
  mounted() {
    (this as any).validation.module.component = this;
  },
  methods: {
    ...mapMutations({
      setLoading: "setLoading",
    }),
    ...mapActions({
      registerUser: "user/registerUser",
      requestAlert: "errorsBag/requestAlert",
      clearActiveNotices: "errorsBag/clearActiveNotices",
      clearAlertResponses: "errorsBag/clearAlertResponses",
      removeNotice: "errorsBag/removeNotice",
      addNotice: "errorsBag/addNotice",
    }),
    validatePhone(eventData) {
      // Validate the input element within the vue-tel-input component
      this.isValidPhone = !!eventData.valid;
    },
    validatePassword() {
      const re =
        /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+\-=\[\]{};':\\|,.<>\/?]).{6,}$/;
      if ((this as any).password) {
        (this as any).validPassword = re.test((this as any).password);
      }
    },
    handleConfirmPassword() {
      if ((this as any).password === (this as any).confirmPassword) {
        (this as any).disableBtn = false;
      } else {
        (this as any).disableBtn = true;
      }
    },
    checkEmail() {
      if (this.$refs.registerEmail) {
        let email = this.$refs.registerEmail as HTMLInputElement;
        this.invalidEmail = email.checkValidity();
        return email.checkValidity();
      }
      this.invalidEmail = false;
      return false;
    },
    async checkEmailAvailable() {
      if (this.email !== "") {
        try {
          const response = await this.$axios(
            `${this.$config.apiURL}/api/Authentication/check-email?email=${this.email}`
          );
          if (response) {
            (this as any).isEmailAvailable = true;
          }
        } catch (error) {
          (this as any).isEmailAvailable = false;
        }
      }
    },

    checkPhone() {
      return (this as any).validation.module.validatePhoneNumber(
        (this as any).phone
      );
    },
    async validateRegister() {
      (this as any).submitting = true;
      // validate, if true, call to register, if that is true, redirect to registerthankyou
      const valid = await (this as any).validation.Validate("register");
      if (valid) {
        const wasRegister = await this.registerUser({
          companyName: (this as any).company,
          firstName: (this as any).firstName,
          lastName: (this as any).lastName,
          phone: (this as any).phone,
          email: (this as any).email,
          password: (this as any).password,
          mailingListOptIn: (this as any).mailingListOptIn,
          newsLetterOptIn: (this as any).newsLetterOptIn,
        });
        if (wasRegister) {
          if (
            wasRegister.constructor === Array &&
            wasRegister[0] &&
            wasRegister[0].hasOwnProperty("propertyName")
          ) {
            if (wasRegister[0].propertyName === "Phone") {
              this.rejectedPhone = true;
            } else if (wasRegister[0].propertyName === "Email") {
              this.rejectedEmail = true;
            } else if (wasRegister[0].propertyName === "Password") {
              this.rejectedPassword = true;
            }
          } else {
            (this as any).$router.push("/registerthankyou");
          }
        }
      }
      (this as any).submitting = false;
    },
  },
  fetchOnServer: false,
});
